var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 20H6.3L0.5 14.2V5.8L6.3 0H14.7L20.5 5.8V14.2L14.7 20ZM6.7 19H14.3L19.5 13.8V6.2L14.3 1H6.7L1.5 6.2V13.8L6.7 19ZM11.4 14.1C11.4 14.6 11 15 10.5 15C10 15 9.6 14.6 9.6 14.1C9.6 13.6 10 13.2 10.5 13.2C11 13.2 11.4 13.6 11.4 14.1ZM9.9 8.1V5H11.2V8.1L10.9 11.9H10.3C10.2 11.9 9.9 8.1 9.9 8.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormError);
export default __webpack_public_path__ + "static/media/form-error.7b7d931c19612e2cedb1aaf666923517.svg";
export { ForwardRef as ReactComponent };